import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";

import { useRefunds } from "../apis";

const useRefundsList = () => {
  const { page, searchValue, sorting, setSorting, setSearchValue, setPage } =
    useManageTable();

  const {
    refunds,
    refetch: refetchRefunds,
    meta
  } = useRefunds({
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: searchValue,
    orderBy: sorting[0]?.id ?? null,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
  });

  return {
    refunds,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading: false,
    sorting,
    refetchRefunds,
    setSorting,
    setSearchValue,
    setPage
  };
};

export default useRefundsList;
